/*
 * Repair page functionality with Native Shopify Discount System
 * 
 * Features:
 * - Device selection (brand, model, repairs)
 * - Dynamic pricing calculation
 * - Native Shopify discount code management (no external systems)
 * - Admin-friendly discount code configuration via theme editor
 * - Secure MD5 hash validation with shop-specific salt
 * - Automatic expiration date checking
 * - Real-time discount application and form regeneration
 * 
 * Discount Management:
 * - All discount codes are managed through a textarea in theme editor
 * - Format: Code|discount_type|discount_amount|expiry_date(optional)
 * - Admins can add/edit/remove codes by editing the textarea
 * - Each code can have: value, type (percentage/fixed), expiration
 * - Codes are automatically validated and expired ones are hidden
 * - Admin preview shows all active codes in theme editor
 */

/**
 * Find the best matching variant for a device model
 * Prioritizes exact matches over partial matches to prevent issues like
 * "iPhone 13" selecting "iPhone 13 mini" variants
 * 
 * @param {Array} variants - Array of variant objects
 * @param {string} optionName - The option name to check (e.g., 'option1')
 * @param {string} deviceModel - The device model to match (e.g., 'iPhone 13')
 * @returns {Object|null} - The best matching variant or null if no match
 */
function findBestVariantMatch(variants, optionName, deviceModel) {
  if (!variants || !Array.isArray(variants) || !optionName || !deviceModel) {
    return null;
  }

  // First pass: Look for exact matches
  for (var i = 0; i < variants.length; i++) {
    var variantModel = variants[i][optionName];
    if (variantModel === deviceModel) {
      return variants[i];
    }
  }

  // Second pass: Look for word boundary matches (prevents partial substring matches)
  for (var i = 0; i < variants.length; i++) {
    var variantModel = variants[i][optionName];
    try {
      // Escape special regex characters in deviceModel
      var escapedDeviceModel = deviceModel.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var wordBoundaryRegex = new RegExp('\\b' + escapedDeviceModel + '\\b', 'i');
      if (wordBoundaryRegex.test(variantModel)) {
        return variants[i];
      }
    } catch (e) {
      // Fallback to simple includes if regex fails
      if (variantModel.includes(deviceModel)) {
        return variants[i];
      }
    }
  }

  return null;
}

function adjustRepairs() {
  var totalTime = 0;
  var totalPrice = 0;
  var formHTML = '';
  var itemCount = 0;
  
  // Reset repair items array for fresh calculation
  window.activeRepairItems = [];

  var modelOptionName = $('repair-section').data('model-option');

  $('.model-list-holder input[type="hidden"]').each(function () {
    var deviceModel = $(this).val();
    var brandName = $(this).closest('.model-list-holder').data('brand');
    var $repairsHolder = $('.model-repairs-holder[data-brand="' + brandName + '"]');

    if (!deviceModel) {
      $repairsHolder.find('.repair-product')
        .removeClass('active')
        .hide();
      $repairsHolder.find('input[type="checkbox"]')
        .prop('checked', false);
      var $selectedItems = $repairsHolder.find('.selected-items');
      var $searchInput = $selectedItems.find('.search-input');
      $selectedItems.find('.value-holder').remove();
      if ($searchInput.length === 0) {
        $selectedItems.append('<input type="text" class="search-input" placeholder="Pesquisar ...">');
      }
      if ($selectedItems.find('.empty').length === 0) {
        $selectedItems.prepend('<span class="empty">' + $repairsHolder.find('p').text() + '</span>');
      }
    } else {
      $repairsHolder.find('.repair-product').each(function () {
        var matchingVariant = null;
        var showItem = 1;
        var optionIndex = 0;
        
        try {
          var prodOBJ = JSON.parse($(this).find(".variant-inventory-data").text());
        } catch (error) {
          console.error('Failed to parse variant data:', error);
          $(this).hide();
          return; // Skip this item
        }

        if (prodOBJ.option1 == modelOptionName) {
          optionIndex = 1;
        } else if (prodOBJ.option2 == modelOptionName) {
          optionIndex = 2;
        } else if (prodOBJ.option3 == modelOptionName) {
          optionIndex = 3;
        } else {
          optionIndex = 1;
        }

        if (optionIndex != 0) {
          var variantOptName = 'option' + optionIndex;
          matchingVariant = findBestVariantMatch(prodOBJ.variants, variantOptName, deviceModel);
          if (!matchingVariant) {
            showItem = 0;
          }
        }

        if (matchingVariant && matchingVariant.price) {
          $(this).find('.product-price').html(formatPrice(matchingVariant.price));
          if ($(this).hasClass('active')) {
            totalPrice += matchingVariant.price;
            totalTime += Number(matchingVariant.time);

            var repairName = $(this).find('.repair-product-title').text().trim();
            
            // Store item data for later processing (after discount calculation)
            window.activeRepairItems = window.activeRepairItems || [];
            window.activeRepairItems.push({
              deviceModel: deviceModel,
              repairName: repairName,
              originalPrice: matchingVariant.price,
              itemCount: itemCount
            });
            
            itemCount++;
          }
        } else {
          showItem = 0;
        }

        $(this).toggle(showItem === 1);
      });
      $repairsHolder.find('.selected-items .empty').remove();
    }
  });

  // Only handle discount functionality if discount elements exist
  if ($('.discount-section').length > 0) {
    // Store the original price before discount
    window.originalTotalPrice = totalPrice;
    
    // Force remove discount if total price is 0 or no repairs are selected
    if (totalPrice === 0 || $('.repair-product.active').length === 0) {
      if (window.activeDiscount) {
        console.log('Force removing discount - price is 0 or no repairs selected');
        removeDiscount();
      }
      $('.discount-section').slideUp(150);
      $('.total-price-holder').html(formatPrice(totalPrice));
    } else {
      // Apply any active discount only if we have a positive price
    applyActiveDiscount();
      $('.discount-section').slideDown(150);
    }
  } else {
    // If no discount section exists, just update the price normally
    $('.total-price-holder').html(formatPrice(totalPrice));
  }

  $('.total-time-holder .time-number').html(totalTime);
  
  // Now generate form HTML with correct pricing (after discount calculation)
  if (window.activeRepairItems && window.activeRepairItems.length > 0) {
    var discountAmount = 0;
    var discountedTotal = window.originalTotalPrice;
    var hasDiscount = window.activeDiscount && window.originalTotalPrice > 0;
    
    if (hasDiscount) {
      if (window.activeDiscount.type === 'percentage') {
        discountAmount = window.originalTotalPrice * (window.activeDiscount.value / 100);
        discountedTotal = window.originalTotalPrice - discountAmount;
      } else if (window.activeDiscount.type === 'fixed') {
        discountAmount = parseFloat(window.activeDiscount.value) * 100;
        discountedTotal = Math.max(0, window.originalTotalPrice - discountAmount);
      }
    }
    
    // Calculate per-item discount if applicable (with zero-division protection)
    var itemDiscountRatio = 1;
    if (hasDiscount && window.originalTotalPrice > 0) {
      itemDiscountRatio = discountedTotal / window.originalTotalPrice;
    }
    
    // Generate item form fields with correct prices (with null safety)
    if (window.activeRepairItems && Array.isArray(window.activeRepairItems)) {
      window.activeRepairItems.forEach(function(item, index) {
        if (!item || typeof item.originalPrice !== 'number') {
          console.error('Invalid repair item data:', item);
          return; // Skip invalid items
        }
        
        var finalPrice = hasDiscount ? Math.round(item.originalPrice * itemDiscountRatio) : item.originalPrice;
        var formattedPrice = formatPrice(finalPrice).replace(/<sup[^>]*>.*<\/sup>/, '').replace(/<[^>]*>/g, '').trim();
      
      formHTML += `
        <div class="repair-holder" data-id="${index}">
          <input type="hidden" name="items[${index}][product]" value="${item.deviceModel}">
          <input type="hidden" name="items[${index}][repair]" value="${item.repairName}">
          <input type="hidden" name="items[${index}][price]" value="${formattedPrice}">
          <input type="hidden" name="items[${index}][original_price]" value="${formatPrice(item.originalPrice).replace(/<[^>]*>/g, '').trim()}">
        </div>
      `;
      });
    } else {
      console.warn('No active repair items found for form generation');
    }
    
    // Add discount information to form data
    if (hasDiscount) {
      formHTML += `
        <div class="discount-holder">
          <input type="hidden" name="discount[applied]" value="true">
          <input type="hidden" name="discount[code]" value="${window.activeDiscount.code}">
          <input type="hidden" name="discount[type]" value="${window.activeDiscount.type}">
          <input type="hidden" name="discount[value]" value="${window.activeDiscount.value}">
          <input type="hidden" name="discount[amount]" value="${formatPrice(discountAmount).replace(/<[^>]*>/g, '').trim()}">
          <input type="hidden" name="pricing[original_total]" value="${formatPrice(window.originalTotalPrice).replace(/<[^>]*>/g, '').trim()}">
          <input type="hidden" name="pricing[discounted_total]" value="${formatPrice(discountedTotal).replace(/<[^>]*>/g, '').trim()}">
          <input type="hidden" name="pricing[savings]" value="${formatPrice(discountAmount).replace(/<[^>]*>/g, '').trim()}">
        </div>
      `;
    } else {
      formHTML += `
        <div class="pricing-holder">
          <input type="hidden" name="discount[applied]" value="false">
          <input type="hidden" name="pricing[original_total]" value="${formatPrice(totalPrice).replace(/<[^>]*>/g, '').trim()}">
          <input type="hidden" name="pricing[discounted_total]" value="${formatPrice(totalPrice).replace(/<[^>]*>/g, '').trim()}">
          <input type="hidden" name="pricing[savings]" value="€0,00">
        </div>
      `;
    }
    
    // Don't clear items array - keep it for discount recalculations
    // window.activeRepairItems = []; // ✅ Keep items for discount application
  }
  
  $('.rapiars--formSubmit .form-data-holder').html(formHTML);

  if ($('.repair-product.active').length > 2) {
    $('.button--show-contact').slideDown(150);
  } else {
    $('.button--show-contact').slideUp(150);
    $('.forms-holder').slideDown(150);
    $('.contact-form-holder').slideUp(150);
  }

  updateContactForm();
}

// Function to apply the active discount
function applyActiveDiscount() {
  // Check if discount elements exist before proceeding
  if ($('.discount-section').length === 0) {
    return;
  }
  
  var totalPrice = window.originalTotalPrice || 0;
  var activeDiscount = window.activeDiscount || null;
  
  console.log('Applying discount:', {
    originalPrice: totalPrice,
    discount: activeDiscount
  });
  
  if (activeDiscount) {
    var discountAmount = 0;
    var discountText = '';
    var discountedPrice = totalPrice;
    
    if (activeDiscount.type === 'percentage') {
      discountAmount = totalPrice * (activeDiscount.value / 100);
      discountedPrice = totalPrice - discountAmount;
      discountText = `${activeDiscount.value}% de desconto`;
    } else if (activeDiscount.type === 'fixed') {
      // Convert fixed amount to cents if needed (since prices are in cents)
      discountAmount = parseFloat(activeDiscount.value) * 100;
      discountedPrice = Math.max(0, totalPrice - discountAmount);
      discountText = `${formatPrice(discountAmount)} de desconto`;
    }
    
    console.log('Discount calculated:', {
      discountAmount: discountAmount,
      discountedPrice: discountedPrice
    });
    
    // Show the original price crossed out
    $('.total-price-original').html(formatPrice(totalPrice));
    $('.total-price-original').slideDown(200);
    
    // Update the current price with the discounted price
    $('.total-price-holder').html(formatPrice(discountedPrice));
    
    // Hide the input section and show the success card with animation
    $('.discount-input-section').slideUp(200);
    setTimeout(() => {
      $('#discount-applied-section').slideDown(300);
      $('.discount-code-name').text(activeDiscount.code);
    }, 200);
    
    // Note: Discount information is displayed but not sent to external collect page
  } else {
    // Hide the original price
    $('.total-price-original').slideUp(200);
    
    // Reset to original price
    $('.total-price-holder').html(formatPrice(totalPrice));
    
    // Hide success card and show input section with animation
    $('#discount-applied-section').slideUp(200);
    setTimeout(() => {
      $('.discount-input-section').slideDown(300);
    }, 200);
    
    // Note: No hidden form fields to clear since discount info isn't sent to external collect page
  }
  
  console.log('Price display updated');
}

// Function to remove the active discount
function removeDiscount() {
  console.log('Removing discount and resetting UI');
  window.activeDiscount = null;
  $('#discount-code-input').val('');
  $('#discount-message').html('');
  
  // Reset the price display
  const originalPrice = window.originalTotalPrice || 0;
  $('.total-price-holder').html(formatPrice(originalPrice));
  
  // Force hide all discount-related elements immediately
  $('.total-price-original').hide();
  $('#discount-applied-section').hide();
  $('.discount-code-name').text('');
  
  // Force show the input section immediately
  $('.discount-input-section').show();
  
  console.log('Discount UI reset complete - all elements forced to correct state');
}

// Simple MD5 hash function to match server-side exactly
function md5(string) {
  function rotateLeft(value, amount) {
    const lbits = (value << amount) | (value >>> (32 - amount));
    return lbits & 0xffffffff;
  }
  
  function addUnsigned(x, y) {
    const x4 = (x & 0x40000000);
    const y4 = (y & 0x40000000);
    const x8 = (x & 0x80000000);
    const y8 = (y & 0x80000000);
    const result = (x & 0x3fffffff) + (y & 0x3fffffff);
    if (x4 & y4) {
      return (result ^ 0x80000000 ^ x8 ^ y8);
    }
    if (x4 | y4) {
      if (result & 0x40000000) {
        return (result ^ 0xc0000000 ^ x8 ^ y8);
      } else {
        return (result ^ 0x40000000 ^ x8 ^ y8);
      }
    } else {
      return (result ^ x8 ^ y8);
    }
  }
  
  function f(x, y, z) { return (x & y) | ((~x) & z); }
  function g(x, y, z) { return (x & z) | (y & (~z)); }
  function h(x, y, z) { return (x ^ y ^ z); }
  function i(x, y, z) { return (y ^ (x | (~z))); }
  
  function ff(a, b, c, d, x, s, ac) {
    a = addUnsigned(a, addUnsigned(addUnsigned(f(b, c, d), x), ac));
    return addUnsigned(rotateLeft(a, s), b);
  }
  
  function gg(a, b, c, d, x, s, ac) {
    a = addUnsigned(a, addUnsigned(addUnsigned(g(b, c, d), x), ac));
    return addUnsigned(rotateLeft(a, s), b);
  }
  
  function hh(a, b, c, d, x, s, ac) {
    a = addUnsigned(a, addUnsigned(addUnsigned(h(b, c, d), x), ac));
    return addUnsigned(rotateLeft(a, s), b);
  }
  
  function ii(a, b, c, d, x, s, ac) {
    a = addUnsigned(a, addUnsigned(addUnsigned(i(b, c, d), x), ac));
    return addUnsigned(rotateLeft(a, s), b);
  }
  
  function convertToWordArray(string) {
    let lWordCount;
    const lMessageLength = string.length;
    const lNumberOfWords_temp1 = lMessageLength + 8;
    const lNumberOfWords_temp2 = (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;
    const lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
    const lWordArray = new Array(lNumberOfWords - 1);
    let lBytePosition = 0;
    let lByteCount = 0;
    while (lByteCount < lMessageLength) {
      lWordCount = (lByteCount - (lByteCount % 4)) / 4;
      lBytePosition = (lByteCount % 4) * 8;
      lWordArray[lWordCount] = (lWordArray[lWordCount] | (string.charCodeAt(lByteCount) << lBytePosition));
      lByteCount++;
    }
    lWordCount = (lByteCount - (lByteCount % 4)) / 4;
    lBytePosition = (lByteCount % 4) * 8;
    lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
    lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
    lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
    return lWordArray;
  }
  
  function wordToHex(lValue) {
    let wordToHexValue = "";
    let lByte;
    let lCount;
    for (lCount = 0; lCount <= 3; lCount++) {
      lByte = (lValue >>> (lCount * 8)) & 255;
      wordToHexValue = wordToHexValue + ((lByte < 16) ? "0" : "") + lByte.toString(16);
    }
    return wordToHexValue;
  }
  
  const x = convertToWordArray(string);
  let a = 0x67452301;
  let b = 0xefcdab89;
  let c = 0x98badcfe;
  let d = 0x10325476;
  
  for (let k = 0; k < x.length; k += 16) {
    const aa = a;
    const bb = b;
    const cc = c;
    const dd = d;
    a = ff(a, b, c, d, x[k + 0], 7, 0xd76aa478);
    d = ff(d, a, b, c, x[k + 1], 12, 0xe8c7b756);
    c = ff(c, d, a, b, x[k + 2], 17, 0x242070db);
    b = ff(b, c, d, a, x[k + 3], 22, 0xc1bdceee);
    a = ff(a, b, c, d, x[k + 4], 7, 0xf57c0faf);
    d = ff(d, a, b, c, x[k + 5], 12, 0x4787c62a);
    c = ff(c, d, a, b, x[k + 6], 17, 0xa8304613);
    b = ff(b, c, d, a, x[k + 7], 22, 0xfd469501);
    a = ff(a, b, c, d, x[k + 8], 7, 0x698098d8);
    d = ff(d, a, b, c, x[k + 9], 12, 0x8b44f7af);
    c = ff(c, d, a, b, x[k + 10], 17, 0xffff5bb1);
    b = ff(b, c, d, a, x[k + 11], 22, 0x895cd7be);
    a = ff(a, b, c, d, x[k + 12], 7, 0x6b901122);
    d = ff(d, a, b, c, x[k + 13], 12, 0xfd987193);
    c = ff(c, d, a, b, x[k + 14], 17, 0xa679438e);
    b = ff(b, c, d, a, x[k + 15], 22, 0x49b40821);
    a = gg(a, b, c, d, x[k + 1], 5, 0xf61e2562);
    d = gg(d, a, b, c, x[k + 6], 9, 0xc040b340);
    c = gg(c, d, a, b, x[k + 11], 14, 0x265e5a51);
    b = gg(b, c, d, a, x[k + 0], 20, 0xe9b6c7aa);
    a = gg(a, b, c, d, x[k + 5], 5, 0xd62f105d);
    d = gg(d, a, b, c, x[k + 10], 9, 0x2441453);
    c = gg(c, d, a, b, x[k + 15], 14, 0xd8a1e681);
    b = gg(b, c, d, a, x[k + 4], 20, 0xe7d3fbc8);
    a = gg(a, b, c, d, x[k + 9], 5, 0x21e1cde6);
    d = gg(d, a, b, c, x[k + 14], 9, 0xc33707d6);
    c = gg(c, d, a, b, x[k + 3], 14, 0xf4d50d87);
    b = gg(b, c, d, a, x[k + 8], 20, 0x455a14ed);
    a = gg(a, b, c, d, x[k + 13], 5, 0xa9e3e905);
    d = gg(d, a, b, c, x[k + 2], 9, 0xfcefa3f8);
    c = gg(c, d, a, b, x[k + 7], 14, 0x676f02d9);
    b = gg(b, c, d, a, x[k + 12], 20, 0x8d2a4c8a);
    a = hh(a, b, c, d, x[k + 5], 4, 0xfffa3942);
    d = hh(d, a, b, c, x[k + 8], 11, 0x8771f681);
    c = hh(c, d, a, b, x[k + 11], 16, 0x6d9d6122);
    b = hh(b, c, d, a, x[k + 14], 23, 0xfde5380c);
    a = hh(a, b, c, d, x[k + 1], 4, 0xa4beea44);
    d = hh(d, a, b, c, x[k + 4], 11, 0x4bdecfa9);
    c = hh(c, d, a, b, x[k + 7], 16, 0xf6bb4b60);
    b = hh(b, c, d, a, x[k + 10], 23, 0xbebfbc70);
    a = hh(a, b, c, d, x[k + 13], 4, 0x289b7ec6);
    d = hh(d, a, b, c, x[k + 0], 11, 0xeaa127fa);
    c = hh(c, d, a, b, x[k + 3], 16, 0xd4ef3085);
    b = hh(b, c, d, a, x[k + 6], 23, 0x4881d05);
    a = hh(a, b, c, d, x[k + 9], 4, 0xd9d4d039);
    d = hh(d, a, b, c, x[k + 12], 11, 0xe6db99e5);
    c = hh(c, d, a, b, x[k + 15], 16, 0x1fa27cf8);
    b = hh(b, c, d, a, x[k + 2], 23, 0xc4ac5665);
    a = ii(a, b, c, d, x[k + 0], 6, 0xf4292244);
    d = ii(d, a, b, c, x[k + 7], 10, 0x432aff97);
    c = ii(c, d, a, b, x[k + 14], 15, 0xab9423a7);
    b = ii(b, c, d, a, x[k + 5], 21, 0xfc93a039);
    a = ii(a, b, c, d, x[k + 12], 6, 0x655b59c3);
    d = ii(d, a, b, c, x[k + 3], 10, 0x8f0ccc92);
    c = ii(c, d, a, b, x[k + 10], 15, 0xffeff47d);
    b = ii(b, c, d, a, x[k + 1], 21, 0x85845dd1);
    a = ii(a, b, c, d, x[k + 8], 6, 0x6fa87e4f);
    d = ii(d, a, b, c, x[k + 15], 10, 0xfe2ce6e0);
    c = ii(c, d, a, b, x[k + 6], 15, 0xa3014314);
    b = ii(b, c, d, a, x[k + 13], 21, 0x4e0811a1);
    a = ii(a, b, c, d, x[k + 4], 6, 0xf7537e82);
    d = ii(d, a, b, c, x[k + 11], 10, 0xbd3af235);
    c = ii(c, d, a, b, x[k + 2], 15, 0x2ad7d2bb);
    b = ii(b, c, d, a, x[k + 9], 21, 0xeb86d391);
    a = addUnsigned(a, aa);
    b = addUnsigned(b, bb);
    c = addUnsigned(c, cc);
    d = addUnsigned(d, dd);
  }
  
  const temp = wordToHex(a) + wordToHex(b) + wordToHex(c) + wordToHex(d);
  return temp.toLowerCase();
}

// Secure hash function that matches server-side exactly
function secureHash(input, salt) {
  // Create the same salt structure as server-side
  const secureSalt = salt + 'SECURE_DISCOUNT_2024';
  const codeWithSalt = input + secureSalt;
  
  // Use MD5 to match server-side exactly
  return md5(codeWithSalt);
}

// Native Shopify Discount Code Validation
function validateDiscountCode(code) {
  // Input validation
  if (!code || typeof code !== 'string' || code.trim().length === 0) {
    $('#discount-message').html('<span class="discount-error">Por favor, insira um código válido</span>');
    return;
  }
  
  const validationDataElement = document.getElementById('discount-validation-data');
  if (!validationDataElement) {
    $('#discount-message').html('<span class="discount-error">Erro: configuração não encontrada</span>');
    return;
  }
  
  try {
    const validationData = JSON.parse(validationDataElement.textContent);
    
    // Validate data structure
    if (!validationData || !validationData.codes || !Array.isArray(validationData.codes)) {
      throw new Error('Invalid validation data structure');
    }
    
    console.log('Native Shopify discount validation:', validationData);
    console.log('Entered code:', code);
    
    if (!validationData.enabled) {
      $('#discount-message').html('<span class="discount-error">Códigos de desconto não habilitados</span>');
      return;
    }
    
    // Create secure hash of entered code with salt
    const enteredCodeHash = secureHash(code.toUpperCase().trim(), validationData.salt);
    console.log('Validating discount code:', code.toUpperCase().trim());
    console.log('Generated hash:', enteredCodeHash);
    console.log('Available code hashes:', validationData.codes.map(c => c.h));
    
    // Find matching discount code from Shopify blocks
    const matchingCode = validationData.codes.find(codeData => codeData.h === enteredCodeHash);
    
    if (matchingCode) {
      console.log('✅ Discount code matched from textarea configuration:', matchingCode);
      
      // Additional validation for expiration and usage limits
      const currentDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
      
      if (matchingCode.expires && matchingCode.expires !== '2099-12-31' && currentDate > matchingCode.expires) {
        $('#discount-message').html('<span class="discount-error">Código expirado</span>');
        return;
      }
      
      window.activeDiscount = {
        code: matchingCode.code || code.toUpperCase().trim(),
        type: matchingCode.t,
        value: parseFloat(matchingCode.v),
        expires: matchingCode.expires
      };
      
      // Clear any previous error messages
      $('#discount-message').html('');
      
      // Apply the discount and regenerate form data
      applyActiveDiscount();
      adjustRepairs(); // ✅ Regenerate form with discounted prices
      
      // Log successful application for admin
      if (validationData.admin_preview) {
        console.log('🎉 Discount applied successfully in admin preview mode');
      }
      
    } else {
      console.log('❌ No matching discount code found in textarea configuration');
      $('#discount-message').html('<span class="discount-error">Código inválido ou expirado</span>');
      window.activeDiscount = null;
      $('.total-price-holder').html(formatPrice(window.originalTotalPrice || 0));
    }
  } catch (error) {
    console.error('Error validating discount code:', error);
    $('#discount-message').html('<span class="discount-error">Erro ao processar código</span>');
  }
}

function pickRepair() {
  var totalPrice = 0;

  if (totalPrice > 0) {
    var vatPrice = totalPrice / 100 * 23;
    var subtotalPrice = totalPrice - vatPrice;
    $('.total-price').html(formatPrice(totalPrice));
    $('.subtotal-price').html(formatPrice(subtotalPrice));
    $('.vat-price').html(formatPrice(vatPrice));
  } else {
    $('.total-price').html('');
    $('.subtotal-price').html('');
    $('.vat-price').html('');
  }
  $('.subtotal-label .item-count').html($('.product-content-holder.active').length);
}

function updateContactForm() {
  var message = $('.default-message').html();

  // Find the active brand from the repairs holder or brand selection
  var activeBrand = $('.model-repairs-holder:visible').data('brand') || $('.brand-pick-holder input[type="hidden"]').val();
  
  // Get the model name from the model-list-holder tied to the active brand
  var modelName = $('.model-list-holder[data-brand="' + activeBrand + '"] input[type="hidden"]').val() || '';
  message += '\n\n' + modelName + '\n';

  $('.repair-product.active').each(function () {
    message += '\n' +
      $(this).find('input[type="checkbox"]').val().replace(/[\r\n]+/g, '').trim() +
      ' - ' +
      $(this).find('.product-price').html().replace(/[\r\n]+/g, '').trim();
  });

  message += '\n\n' + $('.total-label').html() + ' ' + $('.total-price-holder').html();
  
  // Add discount information if a discount is applied
  if (window.activeDiscount) {
    message += '\n\nCódigo de desconto aplicado: ' + window.activeDiscount.code;
    
    // Calculate the discount amount
    var discountAmount = 0;
    if (window.activeDiscount.type === 'percentage') {
      discountAmount = window.originalTotalPrice * (window.activeDiscount.value / 100);
      message += ' (' + window.activeDiscount.value + '%)';
    } else {
      discountAmount = window.activeDiscount.value;
      message += ' (' + formatPrice(discountAmount) + ')';
    }
    
    message += '\nValor original: ' + formatPrice(window.originalTotalPrice);
    message += '\nDesconto: ' + formatPrice(discountAmount);
  }

  $('#ContactForm-body').val(message);
  if ($('.repair-product.active').length < 3) {
    $('.contact-form-holder').slideUp(300);
  }
}

$(document).ready(function () {
  $('.brand-pick-holder input[type="hidden"]').change(function () {
    var brand = $(this).val();
    $('.model-list-holder').slideUp(150);
    $('.model-repairs-holder').slideUp(150);

    $('.model-list-holder input[type="hidden"]').val('').trigger('change');

    if ($('.model-list-holder[data-brand="' + brand + '"]').length > 0) {
      $('.model-pick-holder').show();
      $('.model-list-holder[data-brand="' + brand + '"]').slideDown(150);
    } else {
      $('.model-pick-holder').hide();
      $('.model-repairs').hide();
    }
  });

  $('.model-list-holder input[type="hidden"]').change(function () {
    let brand = $(this).closest('.model-list-holder').data('brand');
    let model = $(this).val();

    if (!model) {
      $('.model-repairs-holder').slideUp(150);
      $('.model-repairs').hide();
    } else {
      if (!$('.model-repairs-holder[data-brand="' + brand + '"]').is(':visible')) {
        $('.model-repairs-holder').slideUp(150);
        if ($('.model-repairs-holder[data-brand="' + brand + '"]').length > 0) {
          $('.model-repairs').show();
          $('.model-repairs-holder[data-brand="' + brand + '"]').slideDown(150);
        } else {
          $('.model-repairs').hide();
        }
      }
    }
    adjustRepairs();
  });

  $('.model-repairs-holder input[type="hidden"]').change(function () {
    adjustRepairs();
    if ($('.repair-product.active').length > 0) {
      if (!$('.contact-form-holder').is(':visible')) {
        $('.forms-holder').slideDown(150);
      }
    } else {
      $('.forms-holder').slideUp(150);
    }
  });

  $('.button--show-contact').on('click', function (event) {
    if ($(event.target).closest('.info-icon').length) {
      event.preventDefault();
      return;
    }
    updateContactForm();
    $('.forms-holder').slideUp(150);
    $('.contact-form-holder').slideDown(150);
  });

  $('.button--hide-contact').click(function () {
    $('.forms-holder').slideDown(150);
    $('.contact-form-holder').slideUp(150);
  });

  $('.delivery-checkbox').change(function () {
    var selected = $(this);
    $('.delivery-checkbox').each(function () {
      if ($(this).is(selected)) {
        return;
      }
      $(this).prop('checked', false);
    });
  });

  // Discount code functionality
  $('#apply-discount').on('click', function() {
    const discountCode = $('#discount-code-input').val().trim();
    if (discountCode) {
      $('#discount-message').html('<span class="discount-validating">Validando...</span>');
      validateDiscountCode(discountCode);
    } else {
      $('#discount-message').html('<span class="discount-error">Por favor, insira um código</span>');
    }
  });
  
  // Remove discount functionality
  $('#remove-discount').on('click', function() {
    removeDiscount();
    adjustRepairs(); // ✅ Regenerate form without discount
  });
  
  // Allow Enter key to submit discount code
  $('#discount-code-input').on('keypress', function(e) {
    if (e.which === 13) {
      e.preventDefault();
      $('#apply-discount').click();
    }
  });
  
  // Clear discount when no items are selected
  $(document).on('change', '.model-repairs-holder input[type="hidden"]', function() {
    if (window.activeDiscount) {
      // Check if there are still active repair items
      const activeRepairs = $('.repair-product.active').length;
      console.log('Repair selection changed. Active repairs:', activeRepairs);
      if (activeRepairs === 0) {
        console.log('No active repairs - removing discount');
        removeDiscount();
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const customSelects = document.querySelectorAll(".custom-select");

  customSelects.forEach((customSelect) => {
    const selectedItemsContainer = customSelect.querySelector(".selected-items");
    const dropdown = customSelect.querySelector(".dropdown");
    const dropdownItems = customSelect.querySelector(".dropdown-items");
    const hiddenInput = customSelect.querySelector('input[type="hidden"]');
    let searchInput = selectedItemsContainer.querySelector(".search-input");

    if (!searchInput) {
      searchInput = document.createElement("input");
      searchInput.type = "text";
      searchInput.className = "search-input";
      searchInput.placeholder = "Pesquisar ...";
      selectedItemsContainer.appendChild(searchInput);
    }

    const hasItems = dropdownItems.querySelectorAll(".item").length > 0;
    if (!hasItems) {
      dropdown.style.display = "none";
      selectedItemsContainer.style.cursor = "default";
    } else {
      dropdown.style.display = "none";
    }

const updateHiddenInput = () => {
  const selectedItemsContainer = customSelect.querySelector(".selected-items");
  const hiddenInput = customSelect.querySelector('input[type="hidden"]');
  const selectedValues = Array.from(
    selectedItemsContainer.querySelectorAll(".value-holder")
  ).map((span) => span.querySelector('span:not(.remove)').textContent.trim()); // Use full text instead of dataset.value

  if (selectedValues.length === 0) {
    hiddenInput.value = "";
    searchInput.placeholder = "Pesquisar ...";
  } else if (selectedValues.length === 1) {
    hiddenInput.value = selectedValues[0]; // Full text, e.g., "MacBook Air 11\" 2012 a 2015 A1495 / A1465"
    searchInput.placeholder = "";
    searchInput.value = "";
  } else {
    hiddenInput.value = JSON.stringify(selectedValues);
    searchInput.placeholder = "";
    searchInput.value = "";
  }

  const event = new Event("change", { bubbles: true });
  hiddenInput.dispatchEvent(event);
};

    const applyVariantFiltering = () => {
      if (customSelect.classList.contains("model-repairs-holder")) {
        const modelOptionName = document.querySelector("repair-section").dataset.modelOption;
        const brand = customSelect.dataset.brand;
        const deviceModel = document.querySelector(`.model-list-holder[data-brand="${brand}"] input[type="hidden"]`)?.value || "";
        const items = dropdownItems.querySelectorAll(".item");

        if (!deviceModel) {
          items.forEach((item) => {
            item.style.display = "none";
          });
          return;
        }

        items.forEach((item) => {
          let showItem = false;
          const prodOBJ = JSON.parse(item.querySelector(".variant-inventory-data").textContent);
          let optionIndex = 0;

          if (prodOBJ.option1 === modelOptionName) {
            optionIndex = 1;
          } else if (prodOBJ.option2 === modelOptionName) {
            optionIndex = 2;
          } else if (prodOBJ.option3 === modelOptionName) {
            optionIndex = 3;
          } else {
            optionIndex = 1;
          }

          if (optionIndex !== 0) {
            const variantOptName = `option${optionIndex}`;
            const matchingVariant = findBestVariantMatch(prodOBJ.variants, variantOptName, deviceModel);
            showItem = matchingVariant !== null;
          }

          item.style.display = showItem ? "block" : "none";
        });
      }
    };

    selectedItemsContainer.addEventListener("click", () => {
      const isDropdownVisible = dropdown.style.display === "block";
      dropdown.style.display = isDropdownVisible ? "none" : "block";
      selectedItemsContainer.classList.toggle("active", !isDropdownVisible);

      if (!isDropdownVisible) {
        applyVariantFiltering();
        searchInput.focus();
      }
    });

    if (searchInput) {
      searchInput.addEventListener("input", () => {
        const searchTerm = searchInput.value.toLowerCase();
        const items = dropdownItems.querySelectorAll(".item");

        if (dropdown.style.display !== "block") {
          dropdown.style.display = "block";
          selectedItemsContainer.classList.add("active");
          applyVariantFiltering();
        }

        if (customSelect.classList.contains("model-repairs-holder")) {
          const modelOptionName = document.querySelector("repair-section").dataset.modelOption;
          const brand = customSelect.dataset.brand;
          const deviceModel = document.querySelector(`.model-list-holder[data-brand="${brand}"] input[type="hidden"]`)?.value || "";

          if (!deviceModel) {
            items.forEach((item) => {
              item.style.display = "none";
            });
            return;
          }

          items.forEach((item) => {
            const text = item.querySelector(".text-holder").textContent.toLowerCase();
            const matchesSearch = text.includes(searchTerm);
            let showItem = false;
            const prodOBJ = JSON.parse(item.querySelector(".variant-inventory-data").textContent);
            let optionIndex = 0;

            if (prodOBJ.option1 === modelOptionName) {
              optionIndex = 1;
            } else if (prodOBJ.option2 === modelOptionName) {
              optionIndex = 2;
            } else if (prodOBJ.option3 === modelOptionName) {
              optionIndex = 3;
            } else {
              optionIndex = 1;
            }

            if (optionIndex !== 0) {
              const variantOptName = `option${optionIndex}`;
              const matchingVariant = findBestVariantMatch(prodOBJ.variants, variantOptName, deviceModel);
              showItem = matchingVariant !== null;
            }

            item.style.display = matchesSearch && showItem ? "block" : "none";
          });
        } else {
          items.forEach((item) => {
            const text = item.querySelector(".text-holder").textContent.toLowerCase();
            item.style.display = text.includes(searchTerm) ? "block" : "none";
          });
        }
      });

      searchInput.addEventListener("click", (event) => {
        event.stopPropagation();
        if (dropdown.style.display !== "block") {
          dropdown.style.display = "block";
          selectedItemsContainer.classList.add("active");
          applyVariantFiltering();
          searchInput.focus();
        }
      });
    }

    document.addEventListener("click", (event) => {
      if (
        !customSelect.querySelector(".selected-items")?.contains(event.target) &&
        !customSelect.querySelector(".dropdown")?.contains(event.target)
      ) {
        dropdown.style.display = "none";
        selectedItemsContainer.classList.remove("active");
      }
    });

    dropdownItems.addEventListener("change", (event) => {
      const checkbox = event.target;
      const item = checkbox.closest(".item");
      const isMultiValue = !customSelect.classList.contains("single-value");

      if (customSelect.classList.contains("single-value") && checkbox.checked) {
        const allCheckboxes = dropdownItems.querySelectorAll('input[type="checkbox"]');
        allCheckboxes.forEach((cb) => {
          if (cb !== checkbox) {
            cb.checked = false;
            const otherItem = cb.closest(".item");
            otherItem.classList.remove("active");
            const spanToRemove = selectedItemsContainer.querySelector(
              `span[data-value="${cb.value}"]`
            );
            if (spanToRemove) spanToRemove.remove();
          }
        });
        dropdown.style.display = "none";
        selectedItemsContainer.classList.remove("active");
      }

      if (checkbox.checked) {
        item.classList.add("active");

        const span = document.createElement("span");
        span.dataset.value = checkbox.value;
        span.className = "value-holder";

        const labelText = item.querySelector(".text-holder").textContent.trim();
        const valueHolder = document.createElement("span");
        valueHolder.textContent = labelText;

        const icon = item.querySelector(".dropdown-icon");
        if (icon) {
          const iconClone = icon.cloneNode(true);
          span.appendChild(iconClone);
        }

        span.appendChild(valueHolder);

        const price = item.querySelector(".product-price");
        if (price) {
          const priceClone = price.cloneNode(true);
          span.appendChild(priceClone);
        }

        const remove = document.createElement("span");
        remove.textContent = "×";
        remove.className = "remove";
remove.addEventListener("click", (e) => {
  e.stopPropagation();
  checkbox.checked = false;
  item.classList.remove("active");
  span.remove();
  updateHiddenInput();
  adjustRepairs(); // This will handle discount removal if no repairs left
  
  // Immediate check: if no repairs are selected and discount is active, remove it
  if ($('.repair-product.active').length === 0 && window.activeDiscount) {
    console.log('Repair removed - clearing discount immediately');
    removeDiscount();
    adjustRepairs(); // Regenerate form without discount
  }
  
  if (isMultiValue) searchInput.focus();
});

        span.appendChild(remove);
        selectedItemsContainer.insertBefore(span, searchInput);
      } else {
        item.classList.remove("active");
        const spanToRemove = selectedItemsContainer.querySelector(
          `span[data-value="${checkbox.value}"]`
        );
        if (spanToRemove) spanToRemove.remove();
      }

      updateHiddenInput();

      if (isMultiValue && checkbox.checked) {
        searchInput.focus();
      }
    });
  });
});